interface Props {
  onClick: () => void
  label?: string
}

/**
 * Persistent mic button — mirror of FAB at bottom-LEFT so both stay
 * reachable without collision. Same 88px bottom offset above TabBar.
 */
export function FloatingMicButton({ onClick, label = 'Ask BabyOS by voice' }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="fixed left-4 z-40 h-14 w-14 rounded-full flex items-center justify-center active:scale-95 transition-transform"
      style={{
        bottom: 'calc(88px + env(safe-area-inset-bottom))',
        background: 'linear-gradient(180deg, #7B8FF7 0%, #5B72E8 55%, #4258D8 100%)',
        color: 'white',
        boxShadow:
          'inset 0 1px 0 rgba(255,255,255,0.25), 0 10px 28px -8px rgba(91,114,232,0.55), 0 4px 10px rgba(91,114,232,0.20)',
      }}
    >
      <MicIcon size={26} />
    </button>
  )
}

function MicIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="3" width="6" height="12" rx="3" />
      <path d="M5 11a7 7 0 0 0 14 0" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="8" y1="22" x2="16" y2="22" />
    </svg>
  )
}
